import { app } from '../../app.module'
// Youtubeアカウント分析データのインタフェース
interface IYtAccountAnalytics {
  accountIds?: string
  views: number
  viewsPerPost: number
  likes: number
  likesPerPost: number
  dislikes: number
  dislikesPerPost: number
  comments: number
  commentsPerPost: number
  posts: number
  postsPerAccount: number
  targetIndex: number | string
}

/**
 * アカウント推移の変数初期化用のサービス
 * @return {Object} オブジェクト
 */
function AccountChangeInit() {
  return {
    // クリックされたグラフ情報(タイプと値)
    targetInfo: null,
  }
}

/**
 * アカウント詳細のグラフ表示用のサービス
 * @return {Object} オブジェクト
 */
function AccountChangeGraph($rootScope, $q, $mdDialog, $state, $filter) {
  /**
   * setDataPerPost 1投稿あたりの平均をセット
   * @param {boolean} dataPerPostFlg 1投稿あたりの平均フラグ
   * @param {array} data データ
   * @param {array} dataPerPost 1投稿あたりのデータ
   * @return {array} データ
   */
  function setDataPerPost(dataPerPostFlg: boolean, data: {}[], dataPerPost: {}[]) {
    return dataPerPostFlg === false ? data : dataPerPost
  }

  /**
   * setRespondConfigData 反応数グラフのデータをセット
   * @param {boolean} dataPerPostFlg 1投稿あたりの平均フラグ
   * @param {string} snsType SNSタイプ
   * @param {Object} respondConfig 反応数グラフ
   * @param {Object} engagementObject 反応オブジェクト
   * @return {Object} 反応数グラフ
   */
  function setRespondConfigData(
    dataPerPostFlg: boolean,
    snsType: string,
    respondConfig: {
      series: {
        name: string
        data: {}[]
        borderWidth: number
        index: number
      }[]
    },
    engagementObject: {
      respondLikes: {}[]
      respondLikesPerPost: {}[]
      respondComments: {}[]
      respondCommentsPerPost: {}[]
      respondReplies: {}[]
      respondRepliesPerPost: {}[]
      respondQuotes: {}[]
      respondQuotesPerPost: {}[]
      respondRetweets: {}[]
      respondRetweetsPerPost: {}[]
      respondShares: {}[]
      respondSharesPerPost: {}[]
      respondCollects: {}[]
      respondCollectsPerPost: {}[]
    }
  ) {
    switch (snsType) {
      case 'facebook':
        respondConfig.series[2].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondLikes,
          engagementObject.respondLikesPerPost
        )
        respondConfig.series[1].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondComments,
          engagementObject.respondCommentsPerPost
        )
        respondConfig.series[0].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondShares,
          engagementObject.respondSharesPerPost
        )
        break

      case 'twitter':
        respondConfig.series[3].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondReplies,
          engagementObject.respondRepliesPerPost
        )
        respondConfig.series[2].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondQuotes,
          engagementObject.respondQuotesPerPost
        )
        respondConfig.series[1].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondRetweets,
          engagementObject.respondRetweetsPerPost
        )
        respondConfig.series[0].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondLikes,
          engagementObject.respondLikesPerPost
        )
        break

      case 'instagram':
        respondConfig.series[1].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondLikes,
          engagementObject.respondLikesPerPost
        )
        respondConfig.series[0].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondComments,
          engagementObject.respondCommentsPerPost
        )
        break

      case 'line':
        respondConfig.series[2].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondLikes,
          engagementObject.respondLikesPerPost
        )
        respondConfig.series[1].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondComments,
          engagementObject.respondCommentsPerPost
        )
        respondConfig.series[0].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondShares,
          engagementObject.respondSharesPerPost
        )
        break

      case 'tiktok':
        respondConfig.series[3].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondCollects,
          engagementObject.respondCollectsPerPost
        )
        respondConfig.series[2].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondShares,
          engagementObject.respondSharesPerPost
        )
        respondConfig.series[1].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondComments,
          engagementObject.respondCommentsPerPost
        )
        respondConfig.series[0].data = setDataPerPost(
          dataPerPostFlg,
          engagementObject.respondLikes,
          engagementObject.respondLikesPerPost
        )
        break
    }

    return respondConfig
  }

  /**
   * setGraphConfig グラフ設定
   * @param {string} graphType グラフタイプ
   * @param {string} chartType チャートタイプ(column or area)
   * @param {object} periodInfo 期間オブジェクト
   * @param {string} yAxisText yカラムに表示するテキスト
   * @param {boolean} enableLegend Legend表示フラグ
   * @param {array} color 表示する対象の色
   * @param {string} snsType SNSタイプ
   * @param {string} periodType 期間タイプ
   * @param {object} getOptions データを取得するオプション
   * @param {any} showPostList 投稿一覧表示用関数
   * @return {array} データ
   */
  function setGraphConfig(
    graphType: string,
    chartType: string,
    periodInfo: {
      csvPeriodArray: {}[]
      graphPeriodArray: {}[]
    },
    yAxisText: string,
    color: {}[],
    enableLegend: boolean,
    snsType: string,
    periodType: string,
    getOptions,
    showPostList
  ) {
    let legend

    if (enableLegend === true) {
      legend = {
        align: 'right',
        x: -30,
        verticalAlign: 'top',
        y: -2,
        floating: true,
        backgroundColor: 'white',
        borderColor: '#CCC',
        borderWidth: 1,
      }
    } else {
      legend = {
        enabled: false,
      }
    }

    const graphConfig = {
      chart: {
        animation: true,
        renderTo: graphType,
        type: chartType,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 50,
        marginBottom: 45,
        height: 290,
      },
      // Exportボタン
      navigation: {
        buttonOptions: {
          align: 'right',
        },
      },
      // Export設定
      exporting: {
        buttons: {
          contextButton: {
            menuItems: ['downloadPNG', 'downloadJPEG', 'downloadSVG'],
          },
        },
      },
      // 右下のクレジットをOFFにする
      credits: {
        enabled: false,
      },
      title: {
        text: '',
      },
      xAxis: {
        csvPeriodArray: periodInfo.csvPeriodArray,
        categories: periodInfo.graphPeriodArray,
        gridLineColor: '#DDDDDD',
        gridLineWidth: 0,
      },
      yAxis: {
        min: null,
        startOnTick: true,
        title: {
          align: 'high',
          offset: -20,
          text: yAxisText,
          rotation: 0,
          x: 5,
          y: -30,
        },
        lineWidth: 1,
        minTickInterval: 1,
        stackLabels: {
          enabled: false,
          style: {
            fontWeight: 'bold',
            color: 'gray',
          },
        },
        labels: {
          align: 'left',
          x: 5,
          y: -5,
          formatter: function () {
            return $filter('number')(this.value)
          },
        },
      },
      // 凡例をOFFにする
      legend: legend,
      tooltip: {
        // 数字フォーマット
        formatter: function () {
          let tooltip = this.x + '<br/>'

          this.points.forEach((point) => {
            tooltip +=
              '<span style="fill:' +
              point.color +
              '">●</span> ' +
              point.series.name +
              ': <b>' +
              point.y.toLocaleString() +
              '</b><br/>'
          })

          return tooltip
        },
        shared: true,
        borderColor: '#b5b5b5',
        style: {
          fontSize: '13px',
        },
      },
      colors: color,
      plotOptions: {
        column: {
          stacking: 'normal',
        },
        series: {
          marker: {
            enabled: false,
          },
        },
      },
      series: [],
      loading: false,
    }

    switch (graphType + '_' + snsType) {
      case 'respond_facebook':
        graphConfig.series = [
          {
            name: 'シェア',
            data: [],
            borderWidth: 0,
            index: 0,
          },
          {
            name: 'コメント',
            data: [],
            borderWidth: 0,
            index: 1,
          },
          {
            name: 'いいね！',
            data: [],
            borderWidth: 0,
            index: 2,
          },
        ]
        break

      case 'respond_twitter':
        graphConfig.series = [
          {
            name: 'いいね',
            data: [],
            borderWidth: 0,
            index: 0,
          },
          {
            name: 'リポスト',
            data: [],
            borderWidth: 0,
            index: 1,
          },
          {
            name: '引用',
            data: [],
            borderWidth: 0,
            index: 2,
          },
          {
            name: '返信',
            data: [],
            borderWidth: 0,
            index: 3,
          },
        ]
        break

      case 'impressions_twitter':
        graphConfig.series = [
          {
            name: 'インプレッション',
            data: [],
          },
        ]
        break

      case 'respond_instagram':
        graphConfig.series = [
          {
            name: 'コメント',
            data: [],
            borderWidth: 0,
            index: 0,
          },
          {
            name: 'いいね！',
            data: [],
            borderWidth: 0,
            index: 1,
          },
        ]
        // グラフの色指定を3つから2つに変更
        graphConfig.colors.shift()
        break

      case 'respond_line':
        graphConfig.series = [
          {
            name: 'シェア',
            data: [],
            borderWidth: 0,
            index: 0,
          },
          {
            name: 'コメント',
            data: [],
            borderWidth: 0,
            index: 1,
          },
          {
            name: 'いいね',
            data: [],
            borderWidth: 0,
            index: 2,
          },
        ]
        break
      case 'respond_tiktok':
        graphConfig.series = [
          {
            name: 'いいね',
            data: [],
            borderWidth: 0,
            index: 0,
          },
          {
            name: 'コメント',
            data: [],
            borderWidth: 0,
            index: 1,
          },
          {
            name: 'シェア',
            data: [],
            borderWidth: 0,
            index: 2,
          },
          {
            name: 'セーブ',
            data: [],
            borderWidth: 0,
            index: 3,
          },
        ]
        break

      case 'respond_rate_facebook':
      case 'respond_rate_instagram':
      case 'respond_rate_line':
        graphConfig.series = [
          {
            name: '反応率(1投稿あたり)',
            data: [],
          },
        ]

        // グラフの目盛間隔を変更
        graphConfig.yAxis.minTickInterval = 0.01
        break

      case 'respond_rate_tiktok':
        graphConfig.series = [
          {
            name: '反応率',
            data: [],
          },
        ]

        // グラフの目盛間隔を変更
        graphConfig.yAxis.minTickInterval = 0.01
        break

      case 'respond_rate_twitter':
        graphConfig.series = [
          {
            name: '反応率(1投稿あたり)',
            data: [],
          },
        ]

        // グラフの目盛間隔を変更
        graphConfig.yAxis.minTickInterval = 0.01
        break

      case 'post_count_facebook':
      case 'post_count_instagram':
      case 'post_count_line':
      case 'post_count_tiktok':
        graphConfig.series = [
          {
            name: '投稿数',
            data: [],
          },
        ]
        break

      case 'post_count_twitter':
        graphConfig.series = [
          {
            name: '投稿数',
            data: [],
          },
        ]
        break

      case 'account_follower_facebook':
        graphConfig.series = [
          {
            name: 'フォロワー数',
            data: [],
          },
        ]
        break

      case 'account_follower_twitter':
      case 'account_follower_instagram':
      case 'account_follower_youtube':
      case 'account_follower_line':
      case 'account_follower_tiktok':
        graphConfig.series = [
          {
            name: 'フォロワー数',
            data: [],
          },
        ]
        break
      case 'views_youtube':
        graphConfig.series = [
          {
            name: '視聴回数',
            data: [],
          },
        ]
        break
      case 'likes_youtube':
        graphConfig.series = [
          {
            name: '高く評価',
            data: [],
          },
        ]
        break
      case 'dislikes_youtube':
        graphConfig.series = [
          {
            name: '低く評価',
            data: [],
          },
        ]
        break
      case 'comments_youtube':
        graphConfig.series = [
          {
            name: 'コメント',
            data: [],
          },
        ]
        break
      case 'post_count_youtube':
        graphConfig.series = [
          {
            name: '投稿数',
            data: [],
          },
        ]
        break
      case 'plays_tiktok':
        graphConfig.series = [
          {
            name: '再生回数',
            data: [],
          },
        ]
        break
    }

    // フォロワー数グラフの場合、リターン
    if (graphType === 'account_follower') {
      return graphConfig
    }

    for (let index = 0; index < graphConfig.series.length; index = index + 1) {
      graphConfig.series[index].cursor = 'pointer'
      graphConfig.series[index].point = {
        events: {
          click: function () {
            // 分析画面の場合、投稿モーダルを開く
            if ($state.current !== undefined && $state.current.name === 'analytics') {
              openPostListModal(this.category, snsType, periodType, getOptions)
            } else {
              let targetValue = this.category
              if (periodType === 'dayOfMonth') {
                targetValue = periodInfo.csvPeriodArray[this.x]
              }
              // アカウント詳細画面の場合、グラフを非表示にして投稿一覧を表示する
              showPostList(targetValue, periodType)
            }
          },
        },
      }
    }

    return graphConfig
  }

  /**
   * setTargetInfo 対象情報をセット
   * @param {string} time 期間
   * @param {string} periodType 期間タイプ
   */
  function setTargetInfo(time: string, periodType: string) {
    const targetInfo = {
      type: periodType,
      value: null,
    }

    switch (periodType) {
      // 月別の場合
      case 'month':
        targetInfo.value = time.split('月')[0]
        break

      // 曜日別の場合
      case 'dayOfWeek':
        const dayLists = ['日', '月', '火', '水', '木', '金', '土']

        targetInfo.value = dayLists.indexOf(time) + 1
        break

      // 日別の場合
      case 'dayOfMonth':
        targetInfo.value = time.split('日')[0]
        break

      // 時間帯別の場合
      case 'hour':
        targetInfo.value = time.split(':')[0]
        break
    }

    return targetInfo
  }

  /**
   * openPostListModal 投稿一覧モーダルを開く
   * @param {string} time 期間
   * @param {string} snsType SNSタイプ
   * @param {string} periodType 期間タイプ
   * @param {object} getOptions データを取得するオプション
   */
  function openPostListModal(time: string, snsType: string, periodType: string, getOptions) {
    // モーダル用のスコープを新規に作成し、モーダル内で使用するパラメーターを格納
    const modalScope: {
      target: string
      snsType: string
      getOptions: {
        startDate: number
        endDate: number
        targetInfo: {
          type: string
          value: string
        }
        groupId: number
        userId: number
      }
    } = $rootScope.$new()

    // 期間
    modalScope.target = time
    // SNSタイプ
    modalScope.snsType = snsType
    //  取得するオプション
    modalScope.getOptions = JSON.parse(JSON.stringify(getOptions))
    modalScope.getOptions.targetInfo = setTargetInfo(time, periodType)
    modalScope.getOptions.groupId = $rootScope.groupId
    modalScope.getOptions.userId = $rootScope.userId

    // モーダルを表示する
    $mdDialog.show({
      template: require('../post-list-modal/post-list-modal.pug')(),
      scope: modalScope,
      clickOutsideToClose: true,
    })
  }

  /**
   * setPeriodInfo 表示する期間をセット
   * @param {object} startEndDate 期間
   * @param {string} periodType 期間タイプ
   * @return {array} 期間情報
   */
  function setPeriodInfo(
    startEndDate: {
      startDate: number
      endDate: number
    },
    periodType,
    dailyFlg: boolean
  ) {
    // グラフに表示用
    let graphPeriodArray = []
    // CSVに表示用
    let csvPeriodArray = []
    // 期間インデックス
    let periodIndexs = []

    switch (periodType) {
      // 月別
      case 'month':
        let startYear = moment.unix(startEndDate.endDate).year()
        let startMonth = moment.unix(startEndDate.endDate).month() + 1

        const endMonth = moment.unix(startEndDate.startDate).format('YYYY-M')

        // 期間13ヶ月分繰り返す
        for (let i = 0; i < 13; i = i + 1) {
          graphPeriodArray.push(startMonth + '月')
          csvPeriodArray.push(startYear + '年' + startMonth + '月')
          periodIndexs.push(startYear + '-' + startMonth)

          if (endMonth === startYear + '-' + startMonth) {
            break
          }

          startMonth = startMonth - 1
          // 月が0になったら12にする
          if (startMonth <= 0) {
            startMonth = 12
            startYear = startYear - 1
          }
        }
        break

      // 曜日別
      case 'dayOfWeek':
        graphPeriodArray = ['日', '土', '金', '木', '水', '火', '月']
        csvPeriodArray = ['日曜日', '土曜日', '金曜日', '木曜日', '水曜日', '火曜日', '月曜日']
        periodIndexs = ['1', '7', '6', '5', '4', '3', '2']
        break

      // 日別
      case 'dayOfMonth':
        if (dailyFlg === false) {
          for (let i = 31; i > 0; i = i - 1) {
            graphPeriodArray.push(i + '日')
            csvPeriodArray.push(i + '日')
            periodIndexs.push(i)
          }
        } else {
          const days = moment
            .unix(startEndDate.endDate)
            .diff(moment.unix(startEndDate.startDate), 'days')

          for (let i = 0; i <= days; i = i + 1) {
            graphPeriodArray.push(
              moment(moment.unix(startEndDate.endDate)).subtract(i, 'days').format('MM/DD')
            )
            csvPeriodArray.push(
              moment(moment.unix(startEndDate.endDate)).subtract(i, 'days').format('YYYY年MM月DD日')
            )
            periodIndexs.push(
              moment(moment.unix(startEndDate.endDate)).subtract(i, 'days').format('YYYY/MM/DD')
            )
          }
        }

        break

      // 時間帯別
      case 'hour':
        for (let i = 23; i >= 0; i = i - 1) {
          if (i < 10) {
            graphPeriodArray.push('0' + i + ':00')
            csvPeriodArray.push('0' + i + ':00')
          } else {
            graphPeriodArray.push(i + ':00')
            csvPeriodArray.push(i + ':00')
          }
          periodIndexs.push(i)
        }
        break
    }

    graphPeriodArray.reverse()
    csvPeriodArray.reverse()
    periodIndexs.reverse()

    return {
      graphPeriodArray: graphPeriodArray,
      csvPeriodArray: csvPeriodArray,
      periodIndexs: periodIndexs,
    }
  }

  /**
   * setAccountGraphConfig グラフ設定
   * @param {object} getOptions データを取得するオプション
   * @param {string} periodType 期間タイプ
   * @param {string} snsType SNSタイプ
   * @param {boolean} dailyFlg 1日毎に表示フラグ
   * @param {any} showPostList 投稿一覧表示用関数
   * @return {Object} グラフ設定
   */
  function setAccountGraphConfig(
    getOptions,
    periodType: string,
    snsType: string,
    dailyFlg: boolean,
    showPostList
  ) {
    // 3つのグラフ
    const graphConfig = {
      respondConfig: null,
      respondRateConfig: null,
      impressionsConfig: null,
      postCountConfig: null,
      playsConfig: null,
    }

    // 表示する期間リストをセット
    const periodInfo = setPeriodInfo(getOptions.startEndDate, periodType, dailyFlg)
    // グラフの色
    const graphYellow = '#ffde21'
    const graphGreen = '#2ec881'
    const graphRed = '#ed5565'
    const graphBlue = '#1c84c6'
    const graphType = 'column'

    // 反応数グラフ
    graphConfig.respondConfig = setGraphConfig(
      'respond',
      graphType,
      periodInfo,
      '回数',
      [graphBlue, graphRed, graphGreen, graphYellow],
      true,
      snsType,
      periodType,
      getOptions,
      showPostList
    )

    // 反応率グラフ
    graphConfig.respondRateConfig = setGraphConfig(
      'respond_rate',
      graphType,
      periodInfo,
      '%',
      [graphBlue],
      false,
      snsType,
      periodType,
      getOptions,
      showPostList
    )
    // 投稿数グラフ
    graphConfig.postCountConfig = setGraphConfig(
      'post_count',
      graphType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      snsType,
      periodType,
      getOptions,
      showPostList
    )

    // インプレッショングラフ
    if (snsType === 'twitter') {
      graphConfig.impressionsConfig = setGraphConfig(
        'impressions',
        graphType,
        periodInfo,
        '回数',
        [graphBlue],
        false,
        snsType,
        periodType,
        getOptions,
        showPostList
      )
    }

    if (snsType === 'tiktok') {
      graphConfig.playsConfig = setGraphConfig(
        'plays',
        graphType,
        periodInfo,
        '回数',
        [graphBlue],
        false,
        snsType,
        periodType,
        getOptions,
        showPostList
      )
    }

    return {
      periodInfo: periodInfo,
      graphConfig: graphConfig,
    }
  }

  /**
   * setAccountGraphData グラフのデータをセット
   * @param {object} getOptions 取得するオプション
   * @param {boolean} dataPerPostFlg 1投稿あたりの平均フラグ
   * @param {string} periodType 期間タイプ
   * @param {string} snsType SNSタイプ
   * @param {boolean} dailyFlg 1日毎に表示フラグ
   * @param {array} accountPosts account詳細データ
   * @param {any} showPostList 投稿一覧表示用関数
   * @return {Object} グラフ情報
   */
  function setAccountGraphData(
    getOptions,
    dataPerPostFlg: boolean,
    ttPlaysPerPostFlg: boolean,
    dataPerAccountFlg: boolean,
    periodType: string,
    snsType: string,
    dailyFlg: boolean,
    accountPosts,
    showPostList
  ) {
    const deferred = $q.defer()
    // グラフのSeriesをセット
    const config = setAccountGraphConfig(getOptions, periodType, snsType, dailyFlg, showPostList)
    const periodIndexs = config.periodInfo.periodIndexs
    // 3つのグラフ
    const graphConfig = config.graphConfig

    // 反応オブジェクト
    const engagementObject = {
      // いいね
      respondLikes: [],
      respondLikesPerPost: [],
      // 返信
      respondReplies: [],
      respondRepliesPerPost: [],
      // 引用
      respondQuotes: [],
      respondQuotesPerPost: [],
      // コメント
      respondComments: [],
      respondCommentsPerPost: [],
      // リポスト
      respondRetweets: [],
      respondRetweetsPerPost: [],
      // シェア
      respondShares: [],
      respondSharesPerPost: [],
      // セーブ
      respondCollects: [],
      respondCollectsPerPost: [],
    }

    // 投稿数オブジェクト
    const postsObject = {
      posts: [],
      postsPerAccount: [],
    }

    // 再生回数オブジェクト
    const playsObject = {
      plays: [],
      playsPerPost: [],
    }

    // 反応率リスト
    const engagementRateArray = []

    // インプレッション
    const impressionsArray = []
    const impressionsPerPostArray = []

    periodIndexs.forEach((periodIndex) => {
      let accountObject = {
        plays: 0,
        playsPerPost: 0,
        likes: 0,
        likesPerPost: 0,
        comments: 0,
        commentsPerPost: 0,
        retweets: 0,
        retweetsPerPost: 0,
        replies: 0,
        repliesPerPost: 0,
        quotes: 0,
        quotesPerPost: 0,
        impressions: 0,
        impressionsPerPost: 0,
        shares: 0,
        sharesPerPost: 0,
        collects: 0,
        collectsPerPost: 0,
        engagementRate: 0,
        posts: 0,
        postsPerAccount: 0,
      }

      const accountFilter = accountPosts.filter((account) => {
        if (dailyFlg === false) {
          return String(periodIndex) === String(account.targetIndex)
        }

        return periodIndex === moment(account.targetIndex).format('YYYY/MM/DD')
      })

      // この期間にデータがある場合、セット
      if (accountFilter && accountFilter[0]) {
        accountObject = accountFilter[0]
      }

      // 反応オブジェクトをセット
      switch (snsType) {
        case 'facebook':
          // いいね、コメント、シェアのデータをセット(全て投稿と1投稿あたりの平均)
          engagementObject.respondLikes.push(accountObject.likes)
          engagementObject.respondLikesPerPost.push(accountObject.likesPerPost)
          engagementObject.respondComments.push(accountObject.comments)
          engagementObject.respondCommentsPerPost.push(accountObject.commentsPerPost)
          engagementObject.respondShares.push(accountObject.shares)
          engagementObject.respondSharesPerPost.push(accountObject.sharesPerPost)
          break

        case 'twitter':
          // いいね、リポスト、インプレッション、引用、返信のデータをセット(全て投稿と1投稿あたりの平均)
          engagementObject.respondLikes.push(accountObject.likes)
          engagementObject.respondLikesPerPost.push(accountObject.likesPerPost)
          engagementObject.respondRetweets.push(accountObject.retweets)
          engagementObject.respondRetweetsPerPost.push(accountObject.retweetsPerPost)
          engagementObject.respondReplies.push(accountObject.replies)
          engagementObject.respondRepliesPerPost.push(accountObject.repliesPerPost)
          engagementObject.respondQuotes.push(accountObject.quotes)
          engagementObject.respondQuotesPerPost.push(accountObject.quotesPerPost)
          impressionsArray.push(accountObject.impressions)
          impressionsPerPostArray.push(accountObject.impressionsPerPost)
          break

        case 'instagram':
          // いいね、コメントのデータをセット(全て投稿と1投稿あたりの平均)
          engagementObject.respondLikes.push(accountObject.likes)
          engagementObject.respondLikesPerPost.push(accountObject.likesPerPost)
          engagementObject.respondComments.push(accountObject.comments)
          engagementObject.respondCommentsPerPost.push(accountObject.commentsPerPost)
          break

        case 'line':
          // いいね、コメント、シェアのデータをセット(全て投稿と1投稿あたりの平均)
          engagementObject.respondLikes.push(accountObject.likes)
          engagementObject.respondLikesPerPost.push(accountObject.likesPerPost)
          engagementObject.respondComments.push(accountObject.comments)
          engagementObject.respondCommentsPerPost.push(accountObject.commentsPerPost)
          engagementObject.respondShares.push(accountObject.shares)
          engagementObject.respondSharesPerPost.push(accountObject.sharesPerPost)
          break

        case 'tiktok':
          // いいね、コメント、シェア、セーブのデータをセット(全て投稿と1投稿あたりの平均)
          engagementObject.respondLikes.push(accountObject.likes)
          engagementObject.respondLikesPerPost.push(accountObject.likesPerPost)
          engagementObject.respondComments.push(accountObject.comments)
          engagementObject.respondCommentsPerPost.push(accountObject.commentsPerPost)
          engagementObject.respondShares.push(accountObject.shares)
          engagementObject.respondSharesPerPost.push(accountObject.sharesPerPost)
          engagementObject.respondCollects.push(accountObject.collects)
          engagementObject.respondCollectsPerPost.push(accountObject.collectsPerPost)

          // 投稿数オブジェクトをセット
          playsObject.plays.push(accountObject.plays)
          playsObject.playsPerPost.push(accountObject.playsPerPost)
          break
      }

      // 投稿数オブジェクトをセット
      postsObject.posts.push(accountObject.posts)
      postsObject.postsPerAccount.push(accountObject.postsPerAccount)

      engagementRateArray.push(accountObject.engagementRate)
    })

    // 反応数グラフのデータをセット
    graphConfig.respondConfig = setRespondConfigData(
      dataPerPostFlg,
      snsType,
      graphConfig.respondConfig,
      engagementObject
    )

    // 反応率グラフのデータをセット
    graphConfig.respondRateConfig.series[0].data = engagementRateArray

    // 投稿数グラフのデータをセット
    graphConfig.postCountConfig.series[0].data = setDataPerPost(
      dataPerAccountFlg,
      postsObject.posts,
      postsObject.postsPerAccount
    )

    // インプレッショングラフのデータをセット
    if (snsType === 'twitter') {
      graphConfig.impressionsConfig.series[0].data = setDataPerPost(
        dataPerPostFlg,
        impressionsArray,
        impressionsPerPostArray
      )
    }

    // 再生回数グラフのデータをセット
    if (snsType === 'tiktok') {
      graphConfig.playsConfig.series[0].data = setDataPerPost(
        ttPlaysPerPostFlg,
        playsObject.plays,
        playsObject.playsPerPost
      )
    }

    deferred.resolve({
      graphConfig: graphConfig,
      engagementObject: engagementObject,
      postsObject: postsObject,
      playsObject: playsObject,
    })

    return deferred.promise
  }

  /**
   * Youtubeアカウントグラフデータをセット
   * @param {any} getOptions オプション
   * @param {string} periodType 期間タイプ
   * @param {boolean} dailyFlg １日毎の表示フラグ
   * @param {IYtAccountAnalytics[]} accountAnalyticDatas Youtubeアカウント分析のデータ
   * @param {any} showPostList 投稿一覧表示用関数
   * @returns {Object} グラフ設定データ
   */
  function setYoutubeAccountGraphData(
    getOptions: any,
    periodType: string,
    dailyFlg: boolean,
    accountAnalyticDatas: IYtAccountAnalytics[],
    showPostList
  ) {
    // グラフ設定
    const graphConfig = {
      views: null,
      likes: null,
      dislikes: null,
      comments: null,
      posts: null,
    }
    // グラフデータ
    const graphData = {
      views: {
        data: [],
        dataPerPost: [],
      },
      likes: {
        data: [],
        dataPerPost: [],
      },
      dislikes: {
        data: [],
        dataPerPost: [],
      },
      comments: {
        data: [],
        dataPerPost: [],
      },
      posts: {
        posts: [],
        postsPerAccount: [],
      },
    }

    // 表示する期間リストをセット
    const periodInfo = setPeriodInfo(getOptions.startEndDate, periodType, dailyFlg)
    // グラフ設定をセット
    const graphBlue = '#1c84c6'
    const chartType = 'column'
    graphConfig.views = setGraphConfig(
      'views',
      chartType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      'youtube',
      periodType,
      getOptions,
      showPostList
    )
    graphConfig.likes = setGraphConfig(
      'likes',
      chartType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      'youtube',
      periodType,
      getOptions,
      showPostList
    )
    graphConfig.dislikes = setGraphConfig(
      'dislikes',
      chartType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      'youtube',
      periodType,
      getOptions,
      showPostList
    )
    graphConfig.comments = setGraphConfig(
      'comments',
      chartType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      'youtube',
      periodType,
      getOptions,
      showPostList
    )
    graphConfig.posts = setGraphConfig(
      'post_count',
      chartType,
      periodInfo,
      '回数',
      [graphBlue],
      false,
      'youtube',
      periodType,
      getOptions,
      showPostList
    )

    // グラフデータをセット
    const periodIndexs = periodInfo.periodIndexs
    periodIndexs.forEach((periodIndex) => {
      let accountData: IYtAccountAnalytics = {
        views: 0,
        viewsPerPost: 0,
        likes: 0,
        likesPerPost: 0,
        dislikes: 0,
        dislikesPerPost: 0,
        comments: 0,
        commentsPerPost: 0,
        posts: 0,
        postsPerAccount: 0,
        targetIndex: 0,
      }

      const accountFilter = accountAnalyticDatas.filter((account) => {
        if (dailyFlg === false) {
          return String(periodIndex) === String(account.targetIndex)
        }

        return periodIndex === moment(account.targetIndex).format('YYYY/MM/DD')
      })

      // データがない場合は、次の期間を実行
      if (accountFilter && accountFilter.length > 0) {
        accountData = accountFilter[0]
      }
      graphData.views.data.push(accountData.views)
      graphData.views.dataPerPost.push(accountData.viewsPerPost)
      graphData.likes.data.push(accountData.likes)
      graphData.likes.dataPerPost.push(accountData.likesPerPost)
      graphData.dislikes.data.push(accountData.dislikes)
      graphData.dislikes.dataPerPost.push(accountData.dislikesPerPost)
      graphData.comments.data.push(accountData.comments)
      graphData.comments.dataPerPost.push(accountData.commentsPerPost)
      graphData.posts.posts.push(accountData.posts)
      graphData.posts.postsPerAccount.push(accountData.postsPerAccount)
    })

    return {
      graphConfig: graphConfig,
      graphData: graphData,
    }
  }

  /**
   * setAccountFollowerGraph フォロワー数グラフのデータをセット
   * @param {object} startEndDate 期間
   * @param {string} periodType 期間タイプ
   * @param {string} snsType SNSタイプ
   * @param {boolean} dailyFlg 1日毎に表示フラグ
   * @param {array} accountFollowers フォロワー数のデータ
   * @return {Object} グラフ情報
   */
  function setAccountFollowerGraph(
    startEndDate: {
      startDate: number
      endDate: number
    },
    periodType: string,
    snsType: string,
    dailyFlg: boolean,
    accountFollowers
  ) {
    const deferred = $q.defer()
    // 表示する期間リストをセット
    const periodInfo = setPeriodInfo(startEndDate, periodType, dailyFlg)
    const graphBlue = '#1c84c6'
    let graphType = 'column'

    // 1日毎に表示フラグが trueの場合、グラフのタイプをareaにする
    if (dailyFlg === true) {
      graphType = 'line'
    }

    // グラフのSeriesをセット
    const graphConfig = setGraphConfig(
      'account_follower',
      graphType,
      periodInfo,
      '人数',
      [graphBlue],
      false,
      snsType,
      periodType,
      null,
      null
    )
    // 表示する期間リストをセット
    const periodIndexs = periodInfo.periodIndexs
    const followers = []
    let minFollower = null

    periodIndexs.forEach((periodIndex, index) => {
      // デフォルトは前日の値としてセット
      // 前日の値がない場合、0にセット
      let follower = followers[index - 1] ? followers[index - 1] : 0
      const accountFilter = accountFollowers.filter((account) => {
        if (dailyFlg === false) {
          return String(periodIndex) === String(account.targetIndex)
        }
        return periodIndex === moment(account.targetIndex).format('YYYY/MM/DD')
      })

      // この期間にデータがある場合、セット
      if (accountFilter && accountFilter[0]) {
        follower = accountFilter[0].followers
      }

      // 一番低いバリューをセット
      if (follower !== 0 && (minFollower === null || follower < minFollower)) {
        minFollower = follower
      }

      // 投稿数オブジェクトをセット
      followers.push(follower)
    })
    // 投稿数グラフのデータをセット
    graphConfig.yAxis.min = minFollower
    graphConfig.series[0].data = followers
    deferred.resolve(graphConfig)

    return deferred.promise
  }

  return {
    setTargetInfo: setTargetInfo,
    setDataPerPost: setDataPerPost,
    setRespondConfigData: setRespondConfigData,
    setAccountGraphConfig: setAccountGraphConfig,
    setAccountGraphData: setAccountGraphData,
    setAccountFollowerGraph: setAccountFollowerGraph,
    setYoutubeAccountGraphData: setYoutubeAccountGraphData,
  }
}

/**
 * AccountChangeService アカウント推移表示機能関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} AccountChangeInit アカウント推移の変数初期化に関するService
 * @param {Function} AccountChangeGraph アカウント推移のグラフに関するService
 * @return {Object} サービスのオブジェクト
 */
function AccountChangeService(AccountChangeInit, AccountChangeGraph) {
  return {
    Init: AccountChangeInit,
    Graph: AccountChangeGraph,
  }
}

// アカウント推移用のサービスを定義
app
  .factory('AccountChangeService', AccountChangeService)
  .factory('AccountChangeGraph', AccountChangeGraph)
  .factory('AccountChangeInit', AccountChangeInit)
